import React from "react";
import { Oval } from "react-loader-spinner";
import "./Loader.scss";

const Loader = ({ isVisible }) => {
  if (!isVisible) return null; 

  return (
    <div className="loader-overlay">
      <Oval
        height={80}
        width={80}
        color="#2c3d8f"
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#2c3d8f"
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
};

export default Loader;
